<template>
    <input
        :type="inFocus ? 'number' : 'text'"
        ref="inputElement"
        :value="inFocus ? modelValue : formattedValue"
        @input="onInput"
        inputmode="numeric"
        :disabled="disabled"
        :min="min"
        :step="step"
        @blur="setFocus(false)"
        @focus="setFocus(true)"
    />
</template>

<script lang="ts">
export default {
    compatConfig: {
        MODE: "compatible",
    },
};
</script>

<script setup lang="ts">
import { computed, ref } from "vue";

const props = defineProps({
    modelValue: Number,
    disabled: Boolean,
    min: Number,
    step: Number,
});

const inFocus = ref(false);

const inputElement = ref<HTMLInputElement>();

function setFocus(v: boolean) {
    if (inFocus.value === v) {
        return;
    }
    if (v) {
        inFocus.value = true;

        // nextTick(() => {
        //     if (!numberInput.value)
        //         throw new Error("numberInput is not defined");
        //     numberInput.value.focus();
        //     if (selectionStart != null && selectionEnd != null) {
        //         numberInput.value.setSelectionRange(
        //             selectionStart,
        //             selectionEnd
        //         );
        //     }
        // });
    } else {
        inFocus.value = false;
    }
}

const emit = defineEmits(["update:modelValue"]);

const formattedValue = computed(() => {
    if (props.modelValue != null)
        return new Intl.NumberFormat("da-DK").format(props.modelValue);
    return undefined;
});

const onInput = (event: Event) => {
    const eventTarget = event.target as HTMLInputElement;
    if (eventTarget.type === "text") {
        event.preventDefault();
        setFocus(true);
        return;
    }
    const value = eventTarget.valueAsNumber;
    if (isNaN(value)) {
        emit("update:modelValue", undefined);
    } else {
        emit("update:modelValue", value);
    }
};

// watch(
//     () => props.modelValue,
//     (newValue) => {
//         if (newValue == null || isNaN(newValue)) {
//             emit("update:modelValue", undefined);
//         }
//     }
// );
</script>
